import RewardsPreview from '../Rewards/RewardsPreview';
import GiftCardsPreview from '../GiftCards/GiftCardsPreview';
import useScrollToSection from '../../../../hooks/useScrollToSection';
import useHasAccessToGiftCards from '../../../../hooks/useHasAccessToGiftCards';
import { REWARD_PREVIEW_TYPES } from '../../config/rewards';
import MarketingSlider from '../../global/MarketingSlider';

import './DashboardRewards.scss';

const DashboardRewards = () => {
  useScrollToSection();
  const {
    isLoading: isLoadingHasAccessToGiftCards,
    hasAccessToGiftCards,
  } = useHasAccessToGiftCards();

  return (
    <div className="DashboardRewards">
      <div className="DashboardRewards__container">
        <MarketingSlider />
        <RewardsPreview
          title="For You"
          type={REWARD_PREVIEW_TYPES.EXCLUSIVE}
          showOnEmptyResults
        />
        <RewardsPreview />
        {!isLoadingHasAccessToGiftCards && hasAccessToGiftCards && (
          <GiftCardsPreview />
        )}
      </div>
    </div>
  );
};

export default DashboardRewards;
